export default "__VITE_ASSET__b801f776__"